<template>
    <page-wrapper>
        <page-header>
            <template v-slot:breadcrumbs>
                <q-breadcrumbs-el :label="$tc('views.admin.eco-hub.tech-user.tech-user', 1)" :to="{ name: 'eco-hub-tech-user-detail' }" />
                <q-breadcrumbs-el :label="$tc('views.admin.eco-hub.tech-user.enroll-tech-user', 1)" :to="{ name: 'eco-hub-tech-user-create' }" />
            </template>

            <h1>{{ $tc('views.admin.eco-hub.tech-user.tech-user', 1) }}</h1>
        </page-header>

        <div class="row print-row-lg">
            <grid-card
                :columns="{
                    'xs': 12,
                    'sm': 12,
                    'md': 8,
                    'lg': 6,
                    'xl': 6,
                }"
                :heading="$tc('views.admin.eco-hub.tech-user.enroll-tech-user', 1)"
                :heading-info="$t('views.admin.eco-hub.tech-user.tech-user--info--short')"
                container-type-normal
            >
                <eco-hub-tech-user-form ref="ecoHubTechUserForm" @cancel="onCancel" @submit="onSubmit" />
            </grid-card>
        </div>
    </page-wrapper>
</template>

<script>
import { EcoHubTechUser } from '@/models/ecoHubTechUser'
import EcoHubTechUserForm from '@/components/ecoHub/EcoHubTechUserForm.vue'
import { useRouter } from '@/composables/router'
import { ref } from 'vue'
import { useQuasar } from '@/composables/quasar'
import { useI18n } from '@/composables/i18n'

export default {
    name: 'EcoHubTechUserCreate',
    meta () {
        return {
            title: this.$tc('views.admin.eco-hub.tech-user.enroll-tech-user', 1),
        }
    },
    components: {
        EcoHubTechUserForm,
    },
    setup () {
        // Composables
        const $q = useQuasar()
        const router = useRouter()
        const { t, tc } = useI18n()

        // Template refs
        const ecoHubTechUserForm = ref(null)

        // Functions
        function onCancel () {
            router.push({ name: 'eco-hub-tech-user-detail' })
        }
        function onSubmit (formData) {
            EcoHubTechUser.create(formData)
                .then(() => {
                    $q.notify({
                        type: 'positive',
                        message: tc('common.notifications.eco-hub.tech-user.tech-user-enrolled-success', 1),
                    })
                    router.replace({ name: 'eco-hub-tech-user-detail' })
                })
                .catch(error => {
                    ecoHubTechUserForm.value.formComponent.formBuilder.showFormErrorMessage(error)
                    ecoHubTechUserForm.value.formComponent.formBuilder.resetFormSubmitStatus()
                })
        }

        return {
            ecoHubTechUserForm,
            onCancel,
            onSubmit,
        }
    },
}
</script>
